import moment from 'moment';
import { moduleScnTitleMap } from './code';
import { nvl } from 'utils/nvl';

import { graphOrder } from 'utils/code';

// 데이터맵 리스트
export const fnCreateDataMapList = (labels, props) => {
  const result = labels.map(label => {
    return ({
      label: label,
      title: moduleScnTitleMap[label].title,
      scn: moduleScnTitleMap[label].scn,
      data: nvl(props[`${label}`], [])
    })
  });

  return result;
}

// 각 카테고리 데이터 정리 - 각각
export const fnCreateArrByStatus = (dataMapList, criterion, noneModuleTerm) => {
  const list = [];
  
  dataMapList.forEach((map) => {
    map.data.forEach(data => {
      const selectedCriterion = criterion[map.label === 'ph' && data.moduleScn === '5' ? 'ph_leakage' : map.label];
      const [status, flagForOrderByStatus] = data.moduleScn === '3' ? fnComparedValueAndCriterionByLeakage(data, data.moduleScn + '', selectedCriterion, noneModuleTerm) : fnComparedValueAndCriterion(data, data.moduleScn + '', selectedCriterion, noneModuleTerm);

      list.push(
        {
          title      : map.title,
          scn        : map.scn,
          criterion  : selectedCriterion,
          status     : status,
          statusFlag : flagForOrderByStatus,
          ...data,
          rgstDt   : moment(data.rgstDt).format('YYYY-MM-DD HH:mm:ss')
        }
      )
    });
  });
  
  return list.sort((a, b) => { return b.statusFlag - a.statusFlag; });
}

// 각 카테고리 데이터 정리 - 그룹별
export const fnCreateArrByStatusForGroup = (dataMapList, criterion, noneModuleTerm) => {
  const list = [];
  const selectedCriterion = {...criterion, ph: {...criterion.ph, ...criterion.ph_leakage}};
  
  dataMapList.forEach((map) => {
    const checkerData = fnStatusChecker(map.title, map.data, selectedCriterion[map.label], noneModuleTerm);
    list.push(checkerData);
  });
  
  return list.sort((a, b) => { return b.statusFlag - a.statusFlag; });
}

// 데이터 warning, danger 여부 체크 - 그룹별 정리에서 사용
export const fnStatusChecker = (title, data, criterion, noneModuleTerm) => {
  const statusByModules = [];
  const addedStatusDataToModules = data.map(dataByModule => {
    const [status, flagForOrderByStatus] = dataByModule.moduleScn === '3' ? fnComparedValueAndCriterionByLeakage(dataByModule, dataByModule.moduleScn + '', criterion, noneModuleTerm) : fnComparedValueAndCriterion(dataByModule, dataByModule.moduleScn + '', criterion, noneModuleTerm);

    statusByModules.push(status);
    dataByModule['status'] = status;
    dataByModule['statusFlag'] = flagForOrderByStatus;

    return {...dataByModule};
  });
  
  const sortedModules = addedStatusDataToModules.sort((a, b) => { return b.statusFlag - a.statusFlag; });
  
  return {'title'          : title, 
          'statusByModules': statusByModules, 
          'modulesData'    : sortedModules, 
          'criterion'      : criterion,
          'statusFlag'     : sortedModules.length > 0 ? sortedModules[0].statusFlag : 1};
}

export const fnComparedValueAndCriterion = (log, moduleScn, criterionMap, noneModuleTerm) => {
  const logDate = moment(log.rgstDt);
  const today = moment();
  if (moment.duration(today.diff(logDate)).asMinutes() > noneModuleTerm) {
    return ['none', 2];
  }

  for (let i = 0; i < graphOrder[moduleScn].length; i++) {
    const keyByType = graphOrder[moduleScn][i];
    const statusValue = log[keyByType];
    const criterion = criterionMap[keyByType];
    
    for (let i = 0; i < criterion.length; i++) {
      const cMap = criterion[i];
      const standType = cMap.standType;
      const standRange = cMap.standRange;
      const criterionStandVal = cMap.standVal;

      if (standType === 'criterion') {
        continue;
      }

      const flagForOrderByStatus = (standType === 'warning' ? 3 : 4);
      
      switch (standRange) {
        case 'A':
          if (criterionStandVal < statusValue) {
            return [standType, flagForOrderByStatus];
          }
          break;
        case 'B':
          if (criterionStandVal <= statusValue) {
            return [standType, flagForOrderByStatus];
          }
          break;
        case 'C':
          if (criterionStandVal >= statusValue) {
            return [standType, flagForOrderByStatus];
          }
          break;
        case 'D':
          if (criterionStandVal > statusValue) {
            return [standType, flagForOrderByStatus];
          }
          break;
        default:
          break;
      }
    }
  };

  return ['blue', 1];
}

export const fnComparedValueAndCriterionByLeakage = (log, moduleScn, criterionMap, noneModuleTerm) => {
  const logDate = moment(log.rgstDt);
  const today = moment();

  if (moment.duration(today.diff(logDate)).asMinutes() > noneModuleTerm) {
    return ['none', 2];
  }
  if (log.leakage > 0 || log.leakage2 > 0 || log.leakage3 > 0) {
    return ['danger', 4];
  }
  else {
    return ['blue', 1];
  }
}